import api from 'api'
import { EXPENSES_RECIEVED, EXPENSE_SAVED, EXPENSE_DELETED, EXPENSE_UNLOADED } from './types'

export const expenseSaved = data => ({
  type: EXPENSE_SAVED,
  data
})

export const expenseDataRecieved = data => ({
  type: EXPENSES_RECIEVED,
  data
})

export const expenseDeleted = data => ({
  type: EXPENSE_DELETED,
  data
})

export const expenseDataUnload = () => ({
  type: EXPENSE_UNLOADED
})

export const unloadExpenses = () => dispatch => {
  dispatch(expenseDataUnload())
}

export const deleteExpense = data => dispatch =>
  api.bmc.expenses.deleteExpense(data).then(()=>{
    dispatch(expenseDeleted(data))
  })

export const getExpenses = planid => dispatch =>
  api.bmc.expenses.getExpenses(planid).then(res => {
    dispatch(expenseDataRecieved(res))
  })

export const saveExpense = data => dispatch => 
  api.bmc.expenses.postExpense(data).then(res=> {
    dispatch(expenseSaved(res))
    return res.id
  })
